<div class="row">
  <div class="col">
    <span class="message-text" [innerHtml]="message | translate"></span>
  </div>
</div>
